import { Globals } from "./Globals";

export class QTracker {
  constructor() {
    this.fWSMgr = null;
    this.fEnabled = false;
  }

  Enable() {
    this.fEnabled = true;
  }

  ReportEvent(eventName = "", properties = {}) {
    if (this.fEnabled != true) return;
    if (eventName == null || eventName.length === 0) return;
    if (Globals._accountInfo.ReportToWebDriver()) return;

    var wsMgr = this.fWSMgr;
    if (wsMgr.fAdminLogin || !wsMgr.GetUserInfo().fShouldPendo) console.log(eventName, properties);
    else if (typeof pendo !== "undefined") pendo.track(eventName, properties);
  }

  ReportRecordClipboardEvent(clipboardContent, actionType) {
    if (!clipboardContent || !Array.isArray(clipboardContent)) {
      return;
    }

    var recordCount = 0;
    for (var i = 0; i < clipboardContent.length; i++) {
      var item = clipboardContent[i];
      if (item && item.fLayout && item.fSerialDBObj) {
        recordCount++;
      }
    }

    if (recordCount <= 0) {
      return;
    }

    this.ReportEvent("chart_mode.clipboard.saved", {
      action: actionType.toLowerCase(),
      record_count: recordCount
    });
  }
}
